/* unplugin-vue-components disabled */import { render } from "./CompanyStat.vue?vue&type=template&id=268769bb"
import script from "./CompanyStat.vue?vue&type=script&lang=js"
export * from "./CompanyStat.vue?vue&type=script&lang=js"

import exportComponent from "/myfunnl/isspadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__